import {
  Calendars,
  EventsBasics,
  EventsManager,
  FAQs,
  MapsBasics,
  MapsManager,
  TimelineBasics,
  TimelinesManager,
} from "../Modals/forms/HelpTopics";
export const helpTopics = [
  {
    name: "Timelines Basics",
    key: "timelinesBasics",
    content: ``,
    page: TimelineBasics,
    codex: "",
    keywords: "timeline time lane event create delete hide show",
    editor: true,
  },
  {
    name: "Timelines Manager",
    key: "timelinesManager",
    content: ``,
    page: TimelinesManager,
    codex: "",
    keywords: "timelines timeline list manager edit delete create",
    editor: true,
  },
  {
    name: "Calendars",
    key: "calendar",
    content: ``,
    page: Calendars,
    codex: "",
    keywords: "calendar truetime time date edit create",
    editor: false,
  },
  {
    name: "Events Basics",
    key: "eventsBasics",
    content: ``,
    page: EventsBasics,
    codex: "",
    keywords: "event historical entry create delete edit",
    editor: false,
  },
  {
    name: "Events Manager",
    key: "eventsManager",
    content: ``,
    page: EventsManager,
    codex: "",
    keywords: "find list event events manager mass move delete",
    editor: false,
  },
  {
    name: "Maps Basics",
    key: "mapsBasics",
    content: ``,
    page: MapsBasics,
    codex: "",
    keywords: "map maps create edit delete marker location pin",
    editor: true,
  },
  {
    name: "Maps Manager",
    key: "mapsManager",
    content: ``,
    page: MapsManager,
    codex: "",
    keywords: "maps map find list manager create edit delete",
    editor: true,
  },
  {
    name: "FAQS",
    key: "faqs",
    content: ``,
    page: FAQs,
    codex: "",
    keywords: "faq frequent asked question",
    editor: false,
  },

  // {
  //   name: "Timeline Editor",
  //   key: "timelineeditor",
  //   content: ``,
  //   codex: "",
  //   keywords: "timelines editor modal",
  //   editor: true,
  // },
  // {
  //   name: "Timelines Manager",
  //   key: "timelinemanager",
  //   content: ``,
  //   codex: "",
  //   keywords: "timelines manager modal",
  //   editor: true,
  // },
  // {
  //   name: "Events",
  //   key: "events",
  //   content: ``,
  //   codex: "",
  //   keywords: "event history timelines",
  //   editor: true,
  // },
  // {
  //   name: "Event Editor",
  //   key: "eventeditor",
  //   content: ``,
  //   codex: "",
  //   keywords: "event history timelines editor modal",
  //   editor: true,
  // },
  // {
  //   name: '',
  //   key: '',
  //   content: ``,
  //   codex: '',
  //   keywords: '',
  //   editor: false,
  // },
];
